import React, { useMemo } from 'react';
import { DateTime } from 'luxon';
import { Textfit } from 'react-textfit';
import BottomBar from '../../../components/BottomBar';
import { bodyFontSizesBOH, titleFontSizesBOH } from '../../../helpers/utils';
import Comment from './Comment';
import EmptyComment from './EmptyComment';
import './BOHComments.scss';
const formatSatisfaction = rating => {
  if (rating >= 4) return 'Highly Satisfied';
  if (rating === 3) return 'Not Highly Satisfied';
  return 'Not Satisfied';
};
const BOHComments = ({
  metadata,
  data,
  text
}) => {
  var _data$hits;
  const hits = (_data$hits = data === null || data === void 0 ? void 0 : data.hits) !== null && _data$hits !== void 0 ? _data$hits : 0;
  const timezone = data === null || data === void 0 ? void 0 : data.timezone;
  const logo = metadata.logo;
  const accent_color = metadata.accent_color;
  const comments = useMemo(() => (data === null || data === void 0 ? void 0 : data.comments) || [], [data === null || data === void 0 ? void 0 : data.comments]);
  const comment = useMemo(() => comments[hits % comments.length], [comments, hits]);
  const rating = comment === null || comment === void 0 ? void 0 : comment.rating;
  const timestamp = comment === null || comment === void 0 ? void 0 : comment.timestamp;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const {
    formattedDate,
    formattedSatisfaction
  } = useMemo(() => ({
    formattedDate: !!timestamp && DateTime.fromISO(timestamp, {
      zone: timezone
    }).toFormat('cccc, MM/dd \'at\' hh:mm a'),
    formattedSatisfaction: formatSatisfaction(rating)
  }), [rating, timestamp, timezone]);
  const satisfactionColor = useMemo(() => {
    switch (formattedSatisfaction) {
      case 'Highly Satisfied':
        return '#00AE4C';
      case 'Not Satisfied':
        return '#C2344A';
      case 'Not Highly Satisfied':
      default:
        return '#FFBE00';
    }
  }, [formattedSatisfaction]);
  return /*#__PURE__*/React.createElement("div", {
    className: "BOHComments",
    style: {
      '--title-font-size-large': titleFontSizesBOH.large + 'px',
      '--title-font-size-medium': titleFontSizesBOH.medium + 'px',
      '--title-font-size-small': titleFontSizesBOH.small + 'px',
      '--body-font-size-large': bodyFontSizesBOH.large + 'px',
      '--body-font-size-medium': bodyFontSizesBOH.medium + 'px',
      '--body-font-size-small': bodyFontSizesBOH.small + 'px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text",
    style: {
      color: text.title_color,
      fontFamily: text.title_font_family
    }
  }, /*#__PURE__*/React.createElement(Textfit, {
    key: 'title' + text.title_font_family,
    mode: "single",
    min: titleFontSizesBOH.small,
    max: titleFontSizesBOH.large
  }, text.title)), logo && /*#__PURE__*/React.createElement("img", {
    className: "logo",
    src: logo,
    alt: "logo"
  })), comment ? /*#__PURE__*/React.createElement(Comment, {
    comment: comment,
    comentario: comment,
    text: text,
    formattedDate: formattedDate,
    formattedSatisfaction: formattedSatisfaction,
    satisfactionColor: satisfactionColor
  }) : /*#__PURE__*/React.createElement(EmptyComment, {
    text: text
  }), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text.accent_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default BOHComments;